
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.975 12.733a.656.656 0 01-.656.656H4.944a.657.657 0 010-1.312h4.375a.656.656 0 01.656.656zm2.188-7a5.005 5.005 0 01-1.924 3.956.67.67 0 00-.264.528v.11a1.094 1.094 0 01-1.094 1.093h-3.5a1.094 1.094 0 01-1.093-1.093v-.11a.656.656 0 00-.257-.52A5.008 5.008 0 012.1 5.761C2.084 3.036 4.287.767 7.01.701a5.031 5.031 0 015.152 5.032zm-1.313 0a3.72 3.72 0 00-3.809-3.719c-2.012.048-3.64 1.725-3.628 3.74A3.703 3.703 0 004.84 8.662a1.962 1.962 0 01.76 1.446h3.068a1.976 1.976 0 01.76-1.45 3.701 3.701 0 001.422-2.925zm-1.097-.291a2.652 2.652 0 00-1.745-2.188.656.656 0 00-.438 1.237 1.33 1.33 0 01.88 1.094.656.656 0 101.305-.144h-.002z","fill":"#000","fill-opacity":".85"}})])
          )
        }
      }
    